import CommonMedia from '../commons/Media'

export default class DocumentMedia extends CommonMedia {}
